import React from 'react';
import styled from 'styled-components';

const CurrentValueContainer = styled.div`
  padding: 0.1rem 0;
  margin-bottom: 0.15rem;
  text-align: center;
`;

const CurrentValueDisplay = styled.div`
  font-size: 2.1rem;
  font-weight: 700;
  margin: 0;
  color: #007bff;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.75rem;
  }
`;

interface CurrentValueProps {
  currentValue: string;
}

const CurrentValue: React.FC<CurrentValueProps> = ({ currentValue }) => {
  return (
    <CurrentValueContainer>
      <CurrentValueDisplay>{currentValue || '0'}</CurrentValueDisplay>

    </CurrentValueContainer>
  );
};

export default CurrentValue;
